(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(14186);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_components_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83331);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _src_components_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62084);
/* harmony import */ var _src_components_DynamicPageBuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29733);
/* harmony import */ var _utils_CitiesContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8851);
/* harmony import */ var _utils_gtmEvents__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38077);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);








const Home = (data)=>{
    const { isReady , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    const { meta , blocks , cities , url  } = data;
    const { update  } = (0,_utils_CitiesContext__WEBPACK_IMPORTED_MODULE_5__/* .useCitiesState */ .$)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        update(cities);
    }, [
        cities
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (isReady) {
            (0,_utils_gtmEvents__WEBPACK_IMPORTED_MODULE_6__/* .optimizeActivateEvent */ .wx)();
        }
    }, [
        asPath
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_seo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                description: meta.description,
                title: meta.title,
                picture: meta.picture,
                canonicalUrl: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_DynamicPageBuilder__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                blocks: blocks
            })
        ]
    });
};
Home.getLayout = function getLayout(data, component) {
    const { routes , topBars , slugs , companyData , hostUrl  } = data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        topBars: topBars,
        routes: routes,
        slugs: slugs,
        companyData: companyData,
        hostUrl: hostUrl,
        children: component
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,9466,2084,7385,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);